module.exports = __webpack_public_path__ + "media/super_idol.a1e43c83.mp3";